import logo from "../../../../assets/logo.png"

import styles from './tela2.module.css'
import { FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from '@mui/material'
import { AtendimentoFormValues } from '../../whatsappForm'
import { MuiTelInput } from 'mui-tel-input'
import { useEffect, useState } from 'react'

export function Tela2(values: AtendimentoFormValues) {
    const [errorMessage, setErrorMessage] = useState('');
    const [message, setMessage] = useState<string | undefined>('');
    const [handled, setHandled] = useState<boolean>(false);

    useEffect(() => {
        (function (c: any, l: Document, a: string, r: string, i: string) {
            c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
            const t = l.createElement(r) as HTMLScriptElement;
            t.async = true;
            t.src = "https://www.clarity.ms/tag/" + i;
            const y = l.getElementsByTagName(r)[0];
            y.parentNode?.insertBefore(t, y);
        })(window, document, "clarity", "script", "ocynrickpm");
    }, []);

    const handleSubmit = async () => {
        // Validação dos campos
        if (!values.nome.trim()) {
            setErrorMessage('O campo nome é obrigatório.');
            return;
        }
        if (!values.telefone || values.telefone.length < 9) {
            setErrorMessage('Informe o telefone corretamente. O número precisa conter o número do país (55 para o Brasil), DDD e o número de telefone.');
            return;
        }

        // Limpa a mensagem de erro se os campos estiverem corretos
        setErrorMessage('');

        setHandled(true);
        setMessage("Estamos te encaminhando para o Whatsapp...");

        try {
            // Simulação de envio para API ou serviço de chat
            await values.submit(); // Função submit passada pelo componente pai
            setMessage("Redirecionando para o WhatsApp...");

            // Redireciona para o WhatsApp após 1 segundo
            setTimeout(() => {
                window.location.href = "https://wa.me/5583920004180";
            }, 1000);
        } catch (error) {
            console.error(error);
            setMessage("Houve um erro ao iniciar o chat. Verifique as informações e tente novamente.");
            setHandled(false);
        }
    };

    // Função para limpar o erro ao redigitar
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        values.setNome(e.target.value);
        setErrorMessage(''); // Limpa a mensagem de erro ao redigitar
    };

    // Função específica para o MuiTelInput, que passa o valor diretamente
    const handlePhoneChange = (newValue: string) => {
        values.setTelefone(newValue);
        setErrorMessage(''); // Limpa a mensagem de erro ao redigitar
    };

    const ouvirMudancaEmRegiao = (e: React.ChangeEvent<HTMLInputElement>) => {
        const regiao = e.target.value
        if (regiao === 'Sim') {
            values.setRegiao('João Pessoa');
        } else {
            values.setRegiao('Outra região')
        }
        setErrorMessage('')
    }

    return (
        <div className={styles.tela1_container}>
            <div className={styles.content_container}>
                <img src={logo} alt="logo-branca" className={styles.logo_branca} />
                <h4>Que bom ter <b>você</b> por aqui</h4>
                <p>Me diz seu <b>nome</b> e <b>telefone</b> para <br />iniciarmos seu atendimento</p>

                <div className={styles.form_container}>
                    <TextField
                        label="Nome"
                        value={values.nome}
                        onChange={handleNameChange}
                        required={true}
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                        sx={{
                            width: '100%',
                        }}
                    />

                    <MuiTelInput
                        value={values.telefone}
                        label="Número de telefone"
                        onChange={handlePhoneChange}
                        required={true}
                        variant='outlined'
                        InputLabelProps={{ shrink: true }}
                        sx={{
                            width: '100%',
                        }}
                    />

                    <div className={styles.confirma_regiao}>
                        <FormLabel htmlFor="sim" sx={{ color: '#636578' }}>Seu móvel é para a região de <strong>João Pessoa</strong>?</FormLabel>
                        <RadioGroup row aria-label="cidade" name="cidade" value={values.regiao} onChange={ouvirMudancaEmRegiao}>
                            <FormControlLabel
                                value="Sim"
                                control={<Radio sx={{
                                    color: 'organ',
                                    '&.Mui-checked': {
                                        color: '#FF561A',
                                    },
                                }} />}
                                label="Sim"
                            />
                            <FormControlLabel
                                value="Não"
                                control={<Radio sx={{
                                    color: '#636578',
                                    '&.Mui-checked': {
                                        color: '#FF561A',
                                    },
                                }} />}
                                label="Não"
                            />
                        </RadioGroup>

                    </div>

                    {errorMessage && <p className={styles.error_message}>{errorMessage}</p>}
                    {message && <p className={styles.info_message}>{message}</p>}

                    <button disabled={values.regiao === undefined ? true : false} className={styles.submit_button} onClick={handleSubmit}>
                        {handled ? 'Iniciando...' : 'INICIAR ATENDIMENTO'}
                    </button>

                </div>
            </div>
        </div>
    );
}
